import React from 'react';
import { Route } from 'react-router-dom';
import hoistNonReactStatics from 'hoist-non-react-statics';
import qs from 'qs';

let cache = {};
let cacheCount = 0;

export default function withRouter(Component: any) {
  const C = (props: any) => {
    const { wrappedComponentRef, ...rest } = props;

    return (
      <Route
        children={({ location, ...routeRest }) => {
          let query = {};

          if (location.search) {
            // pull out of cache if we can
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            if (cache[location.search]) {
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              query = cache[location.search];
            } else {
              query = qs.parse(location.search, {
                ignoreQueryPrefix: true,
                comma: true,
              });

              // place new query into cache
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              cache[location.search] = query;
              cacheCount += 1;
            }

            // free up some memory
            if (cacheCount > 500) {
              cache = {};
            }
          }

          const modifiedProps = {
            ...routeRest,
            location: {
              ...location,
              query,
            },
            q: query,
          };

          return (
            <Component
              {...rest}
              {...modifiedProps}
              updateUrl={_updateUrl(query, routeRest.match, routeRest.history)}
              ref={wrappedComponentRef}
            />
          );
        }}
      />
    );
  };

  C.displayName = `withRouter(${Component.displayName || Component.name})`;
  C.wrappedComponent = Component;

  return hoistNonReactStatics(C, Component);
}

function _updateUrl(query: any, match: any, history: any) {
  return (update = {}, method = 'replace', pathnameOverride: any) => {
    const modifiedQuery = qs.stringify(
      {
        ...query,
        ...update,
      },
      { addQueryPrefix: true, encode: true }
    );

    history[method]({
      pathname: pathnameOverride || match.url.pathname,
      search: modifiedQuery,
    });
  };
}
